export const MOBILE_APP_TOKEN_COOKIE = 'access';

export const MOBILE_APP_USER_AGENT_REGEX = /ChicoreeApp/i;
